import { render, staticRenderFns } from "./AbsentConfigClass.vue?vue&type=template&id=360c8284&scoped=true"
import script from "./AbsentConfigClass.vue?vue&type=script&lang=js"
export * from "./AbsentConfigClass.vue?vue&type=script&lang=js"
import style0 from "./AbsentConfigClass.vue?vue&type=style&index=0&id=360c8284&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360c8284",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360c8284')) {
      api.createRecord('360c8284', component.options)
    } else {
      api.reload('360c8284', component.options)
    }
    module.hot.accept("./AbsentConfigClass.vue?vue&type=template&id=360c8284&scoped=true", function () {
      api.rerender('360c8284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/AbsentConfigClass.vue"
export default component.exports